module.exports = __webpack_public_path__ + "static/img/icon_cabinet.9d6ca920.png";